import { keyframes } from 'styled-components';
import type { Keyframes } from 'styled-components/dist/types';

const hourglass = keyframes`
  0% {
    transform: rotate(0deg);
  }
  25%, 50% {
    transform: rotate(180deg);
  }
  75%, 100% {
    transform: rotate(360deg);
  }
`;

export const animations: { readonly hourglass: Keyframes } = {
  hourglass,
} as const;

const transitionFunctions = {
  easeFn: 'ease-in-out',
} as const;

const transitionTimings = {
  fast: '0.15s',
  medium: '0.3s',
} as const;

export const transition = {
  functions: transitionFunctions,
  timings: transitionTimings,
} as const;
export type Transition = typeof transition;
